// Auth
export const LOGIN_URL = '/auth/login';
export const AUTH_CHECK_URL = '/auth/ping';
export const LOGOUT_URL = '/auth/logout';

export const REQUEST_OTP = '/auth/request-otp';
export const VERIFY_OTP = '/auth/verify-otp';
export const VERIFY_CARD = '/auth/verify-card';
export const CREATE_PATIENT = 'auth/patient/create';

export const CLAIM_SUBMISSION_URL = '/claim-submission/create';
export const CLAIM_SUBMISSION_LIST_URL = '/claim-submission/list';
export const GET_CLAIM_DETAIL_URL = '/claim-submission/:id/detail';
export const ADD_COMMENT_TO_CLAIM_URL = '/claim-submission/:id/addComment';
export const UPLOAD_DOCS_TO_CLAIM_URL = '/claim-submission/:id/upload-doc';

export const SAVE_BANK_ACCOUNTS_URL = '/patient/save-bank-accounts';
export const ADD_REIMBURSEMENT_URL = '/patient/save-reimbursement';
export const EDIT_REIMBURSEMENT_URL = '/patient/edit-reimbursement';
export const DELETE_REIMBURSEMENT_URL = '/patient/delete-reimbursement';
export const UPDATE_SOAP_PROCESS_URL = '/patient/soap-process';

export const UPLOAD_IMAGE_URL = '/utils/upload-image';
export const UPLOAD_CONTENT_URL = '/utils/upload-content';

export const YODLEE_TOKEN_URL = '/yodlee/token';
export const YODLEE_GET_ACCOUNTS_DETAIL = '/yodlee/accounts';